import { render } from "./PlaceholderSettings.vue?vue&type=template&id=7c67afa8"
import script from "./PlaceholderSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./PlaceholderSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./PlaceholderSettings.vue?vue&type=style&index=0&id=7c67afa8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__